'use client';

import { useTranslation } from 'react-i18next';

import { ACHAccountNumber } from '@sola/ark-core/molecules/ach-fields/ach-account-number.js';
import { ACHName } from '@sola/ark-core/molecules/ach-fields/ach-name.js';
import { ACHRoutingNumber } from '@sola/ark-core/molecules/ach-fields/ach-routing-number.js';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.js';
import { SupporterAchFieldsEnum } from '@sola/schema/dotcom/supporters/paymentMethods.js';

export const PaymentACHFields = () => {
  const { t } = useTranslation('my');

  return (
    <>
      <ACHAccountNumber name={SupporterAchFieldsEnum.accountNumber} required />

      <ACHRoutingNumber name={SupporterAchFieldsEnum.routingNumber} required />

      <ACHName name={SupporterAchFieldsEnum.accountName} required />

      <InputField
        name={SupporterAchFieldsEnum.nickname}
        label={t('addPaymentMethod.form.fields.achNickName')}
        hint={t('addPaymentMethod.form.optional')}
      />
    </>
  );
};
